namespace GeniuzPOS.PosShift {
    export class ReportSaleTaxColumns {
        static columnsKey = 'PosShift.ReportSaleTax';
    }
}
